import React, { useEffect, useState } from "react";
import Swal from "sweetalert2";
import { RegularExpressions } from "../../../Helpers/RegularExpression";
import { ValFormReg } from "../../../Validators/ValForms";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CancelIcon from "@mui/icons-material/Cancel";
import WarningIcon from "@mui/icons-material/Warning";
import PendingIcon from "@mui/icons-material/Pending";
import ErrorIcon from "@mui/icons-material/Error";
import request from "../../../Helpers/API";
import { TextField } from "@mui/material";
import { ValSpecialCharacters } from "../../../Validators/ValSpecialCharacters";
import InfoIcon from "@mui/icons-material/Info";


export const PrecalificacionJDFCondicionado = ({
    folio,
    setLoader,
    loader,
    updateComentarios,
    idproceso = 17,
    upload
}) => {
    const [comentarios, setComentarios] = useState("");
    const [estatus, setEstatus] = useState({});
    const [respuestaPrecalificacion, setRespuestaPrecalificacion] = useState("X");

  



    useEffect(() => {
        setLoader({ ...loader, mostrar: true });
        const post = {
            folio,
            idproceso: idproceso,
            responsable: "J",
        };
        request
            .post(`ACAnalisisDecicion`, post)
            .then((result) => {
                setLoader({ ...loader, mostrar: false });
                setEstatus(result);
            })
            .catch((error) => {
                setLoader({ ...loader, mostrar: false });
                Swal.fire(
                    "ANALISIS DE SOLICITUD DE CREDITO",
                    JSON.stringify(error),
                    "error"
                );
            });
    }, []);
    const onEnviarComentario = (estado) => {
        // const rescomentarios = ValFormReg(
        //   "Comentarios",
        //   comentarios,
        //   RegularExpressions.TextSpecialCharacter,
        //   15,
        //   2000
        // );
        // if (rescomentarios.isValid === false) {
        //   Swal.fire(
        //     "ANALISIS DE SOLICITUD DE CREDITO",
        //     rescomentarios.mensaje,
        //     "error"
        //   );
        //   return;
        // }
        setLoader({ ...loader, mostrar: true });
        const post = {
            folio,
            idproceso: idproceso,
            consecutivo: -1,
            comentarios:
                comentarios.length === 0 ? "PRECALIFICACION APROBATORIA" : comentarios,
            estatus: estado,
            precalificacion: respuestaPrecalificacion,
        };
        request
            .post("ACTimeLineComentarios/GuardarPrecalificacion", post)
            .then((result) => {
                setLoader({ ...loader, mostrar: false });
                setEstatus(result.estado);
               
                setComentarios("");
                if (updateComentarios !== undefined && updateComentarios !== null)
                    updateComentarios();
                upload()
            })
            .catch((error) => {
                setLoader({ ...loader, mostrar: false });
                Swal.fire(
                    "ANALISIS DE SOLICITUD DE CREDITO",
                    JSON.stringify(error),
                    "error"
                );
            });
    };
    const OnGetIcon = ({ icon }) => {
        switch (icon) {
            case "wait":
                return <PendingIcon />;
            case "success":
                return <CheckCircleIcon />;
            case "warning":
                return <WarningIcon />;
            case "error":
                return <ErrorIcon />;
            default:
                <></>;
        }
    };
    const onChange = (prop, value, sbool, smensaje) => {
        setComentarios(value);
    };

    const onCancelarEnviado = () => {
        setRespuestaPrecalificacion("X")
        setComentarios("")
    }
    return (
        <div className="analisis-credito-modal-comentarios-jdf-condicionado">
            <div className="analisis-credito-modal-comentarios-jdf-content">
                <div className="analisis-credito-modal-comentarios-jdf-content-title">
                    <InfoIcon className="icon-info" /> TIEMPO DE RESPUESTA ESTIMADO:{" "}
                    {estatus.tiempoestimado}
                </div>
                {(estatus.habilitar === true && (
                    <div className="analisis-credito-modal-buttons-respuesta-precalificacion">
                        <button
                            className={respuestaPrecalificacion === "A" ? "analisis-credito-modal-respuesta-precalificacion-auto-aprobacion-seleccionado" : "analisis-credito-modal-respuesta-precalificacion-auto-aprobacion"}
                            onClick={() => setRespuestaPrecalificacion("A")}
                        >
                            Autoaprobación
                        </button>
                        <button
                            className={respuestaPrecalificacion === "S" ? "analisis-credito-modal-respuesta-precalificacion-revision-simplificada-seleccionado" : "analisis-credito-modal-respuesta-precalificacion-revision-simplificada"}
                            onClick={() => setRespuestaPrecalificacion("S")}
                        >
                            Revisión simplificada
                        </button>
                        <button
                            className={respuestaPrecalificacion === "C" ? "analisis-credito-modal-respuesta-precalificacion-revision-completa-seleccionado" : "analisis-credito-modal-respuesta-precalificacion-revision-completa"}
                            onClick={() => setRespuestaPrecalificacion("C")}
                        >
                            Revisión completa
                        </button>
                        <button
                            className={respuestaPrecalificacion === "R" ? "analisis-credito-modal-respuesta-precalificacion-rechazado-seleccionado" : "analisis-credito-modal-respuesta-precalificacion-rechazado"}
                            onClick={() => setRespuestaPrecalificacion("R")}
                        >
                            Rechazo
                        </button>
                    </div>
                ))}
                {respuestaPrecalificacion !== "X" && (
                    <div className="analisis-credito-modal-jdf-content-comentarios">
                        {estatus.habilitar === undefined ||
                            estatus.habilitar === null ||
                            estatus.habilitar === false ? (
                            <></>
                        ) : (
                            <>
                                <TextField
                                    fullWidth
                                    size="small"
                                    label="COMENTARIOS"
                                    className="cel-1 analisis-credito-modal-jdf-content-comentarios-text"
                                    multiline
                                    rows={4}
                                    type="text"
                                    // error={condiciones.bcondiciones}
                                    onChange={({ target }) => {
                                        ValSpecialCharacters(
                                            "condiciones",
                                            target.value,
                                            onChange,
                                            true,
                                            500
                                        );
                                    }}
                                    value={comentarios}
                                />
                                <div className="analisis-credito-modal-jdf-content-buttons">
                                    <div
                                        className="analisis-credito-modal-pedido-content-cancel-button"
                                        onClick={() => {
                                            onCancelarEnviado()
                                        }}
                                    >
                                        <CancelIcon />
                                        <div>CANCELAR</div>
                                    </div>
                                    <div
                                        className="analisis-credito-modal-pedido-content-acept-button"
                                        onClick={() => {
                                            onEnviarComentario("A");
                                        }}
                                    >
                                        <CheckCircleIcon />
                                        <div>ACEPTAR</div>
                                    </div>
                                </div>
                            </>
                        )}
                    </div>
                )}
                {estatus.habilitar === undefined ||
                    estatus.habilitar === null ||
                    (estatus.habilitar === false && (
                        <div
                            className={`analisis-credito-modal-pedido-content-comentarios analisis-credito-modal-pedido-content-comentarios-${estatus.icono}`}
                        >
                            <label>Comentarios</label>
                            <div className="analisis-credito-modal-pedido-content-comentarios-svg">
                                <OnGetIcon icon={estatus.icono} />
                            </div>
                            <div className="analisis-credito-modal-pedido-content-comentarios-div">
                                {estatus.comentarios}
                            </div>
                        </div>
                    ))}
            </div>
            <div className="analisis-credito-modal-pedido-footer"></div>
        </div>
    );
};
